import { Button, Cell, Row } from '@dexma/ui-components';
import i18n from 'asset/translation';
import React, { FormEvent, useState } from 'react';
import { useAlertToaster } from 'adapter/in/common/context/Alert';
import { StyledAnimationDiv } from 'adapter/in/common/style';
import { StyledHeading, StyledHomeHeader, StyledInputSearchBar } from 'adapter/in/common/components/Home/style';
import { StyledAlert } from 'adapter/in/advanced-analytics/components/StyledAlert/StyledAlert';

type HomeProps = {
    addButtonProps: {
        displayAddButton: boolean;
        addButton: JSX.Element;
    };
    searchDataId: string;
    headingTitle: string;
    handleSearchChange: (event: FormEvent<HTMLInputElement>) => void;
    children: React.ReactNode;
};

const Home = (props: HomeProps) => {
    const { addButtonProps, headingTitle, handleSearchChange, searchDataId } = props;
    const { message: alertMessage, show: showAlert, type: alertType, style } = useAlertToaster();

    return (
        <>
            <StyledHomeHeader fluid data-testid='home-list' $showAlert={showAlert}>
                <StyledAnimationDiv $animationStyle={style}>
                    <StyledAlert
                        description={alertMessage}
                        type={alertType as 'info' | 'outline' | 'basic' | 'warning' | 'success' | 'error'}
                        showIcon
                    />
                    <Row className='heading'>
                        <Cell>
                            <StyledHeading text={headingTitle} type='h1'>
                                {addButtonProps.displayAddButton && addButtonProps.addButton}
                            </StyledHeading>
                        </Cell>
                        <Cell xs={2}>
                            <StyledInputSearchBar
                                dataId={searchDataId}
                                type='text'
                                placeholder={i18n.t('common.search')}
                                icon='search'
                                onChange={handleSearchChange}
                                data-testid='search-input'
                            />
                        </Cell>
                    </Row>
                    {props.children}
                </StyledAnimationDiv>
            </StyledHomeHeader>
        </>
    );
};

export default Home;
